import React, { Component } from 'react'
import { Container, Content, Hero, HeroBody, Subtitle, Title } from 'bloomer'
import styled from 'styled-components'

// import Breadcrumbs from '../components/breadcrumbs'
import Head from '../components/head'
import Image from '../components/image'
import Layout from '../components/layout'
import Link from '../components/link'

const ShortHeroBody = styled(HeroBody)`
  @media only screen and (min-width: 45rem) {
    padding-top: 9rem !important;
  }
`

const Heading = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;

  @media only screen and (min-width: 45rem) {
    align-items: center;
    flex-flow: row nowrap;
  }
`

const HeadingContent = styled.div`
  width: 100%;

  @media only screen and (min-width: 45rem) {
    margin-right: 1rem;
    width: 50%;
  }
`

const HeadingImage = styled.div`
  width: 100%;

  @media only screen and (min-width: 45rem) {
    width: 50%;
  }
`

const ListWrapper = styled.article`
  margin: 0 auto;

  address {
    font-style: normal;
  }

  .list-overview h1 {
    max-width: 1000px;
    margin: 3rem 0;
    font-size: 2rem;
    font-weight: 700;
    ${'' /* text-align: center; */}
    ${'' /* text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5); */}
    word-break: normal;
  }

  .list-table-of-contents {
    border-radius: 6px;
    box-shadow: 0 20px 70px rgba(0, 0, 0, 0.55);
    margin: 0 auto;
    max-width: 960px;

    ul {
      margin-left: 0;
    }

    nav ul li p a:first-child {
      font-weight: 700;
    }

    li {
      margin: 0.5rem 0;
    }

    a {
      color: rgba(255, 255, 255, 1);
      cursor: pointer;

      &:active,
      :hover,
      :focus {
        color: rgba(11, 100, 233, 1);
      }
    }
  }

  .list-body h1 {
    font-size: 1.8rem;
    font-weight: 700;
    margin: 2rem 0;
  }

  .list-body h2,
  h3,
  h4 {
    margin: 1.5rem 0;
  }

  .list-body h2 {
    font-size: 1.6rem;
    font-weight: 600;
  }

  .list-body h3 {
    font-size: 1.4rem;
    font-weight: 500;
  }

  .list-body h4 {
    font-size: 1.2rem;
    font-weight: 500;
  }

  .list-body ol,
  ul {
    margin-left: 2rem;
  }

  .list-body li {
    font-size: 1.1rem;
    margin: 1rem 0;
  }

  .list-body a {
    font-weight: 500;
  }

  .list-body p {
    font-size: 1.1rem;
    margin: 1rem 0;
  }

  @media only screen and (min-width: 45rem) {
    max-width: 1080px;

    .list-overview h1 {
      font-size: 3rem;
    }

    .list-body h1 {
      margin: 4rem 0;
    }

    .list-body h2,
    h3,
    h4 {
      margin: 2rem 0;
    }

    .list-body h1 {
      font-size: 2rem;
    }

    .list-body h2 {
      font-size: 1.8rem;
    }

    .list-body h3 {
      font-size: 1.6rem;
    }

    .list-body h4 {
      font-size: 1.4rem;
    }

    .list-index-body li {
      font-size: 1.25rem;
    }

    .list-body p {
      font-size: 1.25rem;
      margin: 2rem 0;
    }
  }
`

const Tags = styled.nav`
  display: inline-flex;
  flex-flow: row wrap;
  font-style: normal;
  text-align: left;

  @media only screen and (min-width: 45rem) {
    flex-flow: row nowrap;
  }
`

const Tag = styled(Link)`
  color: rgba(50, 50, 50, 1);
  cursor: pointer;

  &:active,
  :hover,
  :focus {
    color: rgba(11, 100, 233, 1);
  }
`

// const Categories = styled.section`
//   align-items: center;
//   display: flex;
//   flex-flow: row wrap;
// `

// const Category = styled(Link)`
//   background: rgba(11, 100, 233, 1);
//   border-radius: 1rem;
//   color: rgba(255, 255, 255, 1);
//   cursor: pointer;
//   font-size: 0.8rem;
//   margin: 0.5rem 0.5rem 0.5rem 0;
//   padding: 0.5rem 0.75rem 0.5rem 0.75rem;
//   word-break: keep-all;

//   &:last-child {
//     margin-right: 0;
//   }

//   &:active,
//   :hover,
//   :focus {
//     background: rgba(31, 190, 218, 1);
//     color: rgba(255, 255, 255, 1);
//   }

//   @media only screen and (min-width: 45rem) {
//     font-size: 1rem;
//   }
// `

const Meta = styled.span`
  font-size: 0.9rem;
  font-weight: 900;
`

const defaultKeywords = [
  'resources',
  'route',
  'route the service platform',
  'software for service companies',
  'business management software'
]

export class List extends Component {
  render() {
    let {
      data: {
        markdownRemark: { excerpt, fields, frontmatter, html, tableOfContents, timeToRead }
      }
    } = this.props
    let { author, banner, categories, date, description, keywords, section, steps, tags, title, video } = frontmatter
    let { tagSlugs } = fields

    let pathname
    if (this.props.location && this.props.location.pathname) {
      pathname = this.props.location.pathname
    } else if (global.location && global.location.pathname) {
      pathname = global.location.pathname
    } else {
      pathname = '/'
    }

    if (pathname) {
      pathname = pathname.split('/').slice(3)
    }

    let id
    if (pathname[pathname.length - 1].length > 1) {
      id = pathname[pathname.length - 1]
    } else {
      id = pathname[pathname.length - 2]
    }

    if (!author) {
      author = `Route`
    }

    if (!banner) {
      banner = 'assets/logo/route-icon-flat.png'
    }

    if (!categories) {
      categories = pathname
    }

    if (!date) {
      date = Date.now()
    }

    if (!description) {
      description = ``
    }

    if (!excerpt) {
      excerpt = ``
    }

    if (!keywords || !keywords.length) {
      keywords = defaultKeywords
    }

    if (!section) {
      section = `Building Services`
    }

    if (!tags) {
      tags = []
    }

    if (!timeToRead) {
      timeToRead = 'PT300S'
    }

    if (!title) {
      title = `Route Nation News`
    }

    let tagList = []
    if (tagSlugs) {
      tagList = tagSlugs.map((tag, index) => (
        <span key={index}>
          <Tag to={tag}>{tags[index]}</Tag>
          {index < tagSlugs.length - 1 && <>{`,`}&nbsp;</>}
        </span>
      ))

      tags = <Tags>{tagList}</Tags>
    }

    // I don't like how excerpt shows up at the top of the content...
    const __html = html.split('<!-- end of excerpt -->')[1] || html

    let words = __html
      .replace(/<[^>]*>/g, '')
      .split(/\s/)
      .filter(word => /\S/.test(word))

    let wordCount = words && words.length > 0 ? words.length : 0

    let body = words && words.length > 0 ? `${words.slice(0, wordCount <= 250 ? wordCount : 250).join(' ')}...` : ''

    let article = {
      article: true,
      author,
      banner,
      body,
      date,
      description,
      excerpt,
      keywords,
      timeToRead,
      title,
      section,
      video,
      wordCount
    }

    if (steps) {
      let howto = {}
      howto.steps = steps.map(step => ({
        name: step[0],
        text: step[1],
        image: step[2],
        url: step[3]
      }))

      if (video) {
        howto.video = video
      }

      article.howto = howto
      article.video = howto.video
    }

    const Overview = (
      <Hero isColor={`light`} className={`list-overview`}>
        <ShortHeroBody>
          <Container>
            <Meta>
              {tags} | {timeToRead} min read &middot;
            </Meta>
            <Title isSize={1}>{title}</Title>
            <Heading>
              <HeadingContent>
                <Subtitle isSize={4} style={{ fontWeight: '500' }}>
                  Author: {author}
                </Subtitle>
                <Content isSize={`small`}>
                  <address>
                    <a href="mailto:marketing@getroute.com">marketing@getroute.com</a>
                    <br />
                    <a href="tel:+17082323259">(708) 232-3259</a>
                  </address>
                </Content>
                <Content isSize={`small`}>
                  <i>{excerpt}</i>
                </Content>
                <Content isSize={`small`}>
                  <time dateTime={date}>{new Date(date).toLocaleDateString()}</time>
                </Content>
              </HeadingContent>
              <HeadingImage>
                <Image file={banner} />
              </HeadingImage>
            </Heading>
          </Container>
        </ShortHeroBody>
      </Hero>
    )

    let TableOfContents = null
    if (tableOfContents) {
      TableOfContents = (
        <Hero isColor={`black`} className={`list-table-of-contents`}>
          <HeroBody>
            <Container>
              <Subtitle isSize={3} style={{ fontWeight: '700', margin: '0' }}>
                Table Of Contents
              </Subtitle>
              <hr />
              <nav
                dangerouslySetInnerHTML={{
                  __html: tableOfContents.replace('/#', '#')
                }}
              />
            </Container>
          </HeroBody>
        </Hero>
      )
    }

    // let CategoriesSection = null
    // if (categories && categories.length > 0) {
    //   const renderedCategories = categories.map((category, index) => {
    //     // const categoryLink = `/route-nation/collections/${category.replace(/\s/g, '-')}`
    //     const categoryLink = `/route-nation/${pathname
    //       .slice(0, index + 1)
    //       .join('/')}`

    //     const categoryName = category
    //       .split(' ')
    //       .map(CapitalCase)
    //       .join(' ')

    //     return (
    //       <Category key={index} to={categoryLink}>
    //         {categoryName}
    //       </Category>
    //     )
    //   })

    //   CategoriesSection = (
    //     <Hero>
    //       <HeroBody>
    //         <Container>
    //           <Subtitle isSize={2}>Categories</Subtitle>
    //           <Categories>
    //             <Category to={`/route-nation/`}>
    //               Route Nation
    //             </Category>
    //             {renderedCategories}
    //           </Categories>
    //         </Container>
    //       </HeroBody>
    //     </Hero>
    //   )
    // }

    return (
      <Layout>
        <Head article author={author} banner={banner} description={description} keywords={keywords} title={title} />
        {/* <Breadcrumbs {...this.props} /> */}
        <ListWrapper>
          {Overview}
          {TableOfContents}
          <Hero id={id} isSize={`medium`}>
            <HeroBody>
              <Container className={`list-body`} dangerouslySetInnerHTML={{ __html }} />
            </HeroBody>
          </Hero>
          {/* {CategoriesSection} */}
        </ListWrapper>
      </Layout>
    )
  }
}

export default List
